<template>
  <div :class="['sidenav', mobileOpen ? 'mobile-open' : null]">
    <teleport to="body">
      <div
        :class="['sidenav-backdrop', mobileOpen ? 'is-open' : null]"
        v-on:click="closeMobile"
      ></div>
    </teleport>
    <button
      type="button"
      class="sidenav-close"
      v-on:click="closeMobile"
      aria-label="Close menu"
    >
      <font-awesome-icon icon="fa-solid fa-xmark" />
    </button>
    <div class="links">
      <ul>
        <div class="brand-row">
          <div class="brand-mark" aria-hidden="true">
            <span class="brand-bracket">&#91;</span>
            <span class="brand-glyph"></span>
            <span class="brand-bracket">&#93;</span>
          </div>
          <span class="brand-name">Abol Verify</span>
        </div>
        <hr />
        <router-link :to="{ name: DASHBOARD_ROUTE }" v-on:click="closeMobile">
          <li :class="[route == DASHBOARD_ROUTE ? 'selected' : null, 'nav-items']">
            <span class="router-link">
              <font-awesome-icon icon="fa-solid fa-grip" class="fa fa-large" />
              <span class="d-none d-lg-block nav-label">Dashboard</span>
            </span>
          </li>
        </router-link>
        <router-link :to="{ name: ACCOUNTS_ROUTE }" v-on:click="closeMobile">
          <li :class="[isAccountsRoute ? 'selected' : null, 'nav-items']">
            <span class="router-link">
              <font-awesome-icon icon="fa-solid fa-user-group" class="fa" />
              <span class="d-none d-lg-block nav-label">Accounts</span>
            </span>
          </li>
        </router-link>
        <router-link :to="{ name: VERIFICATIONS_ROUTE }" v-on:click="closeMobile">
          <li :class="[route == VERIFICATIONS_ROUTE ? 'selected' : null, 'nav-items']">
            <span class="router-link">
              <font-awesome-icon icon="fa-solid fa-circle-check" class="fa fa-large" />
              <span class="d-none d-lg-block nav-label">Verifications</span>
            </span>
          </li>
        </router-link>
        <router-link :to="{ name: SUBSCRIPTION_PLANS_ROUTE }" v-on:click="closeMobile">
          <li :class="[route == SUBSCRIPTION_PLANS_ROUTE ? 'selected' : null, 'nav-items']">
            <span class="router-link">
              <font-awesome-icon icon="fa-solid fa-layer-group" class="fa" />
              <span class="d-none d-lg-block nav-label">Subscription Plans</span>
            </span>
          </li>
        </router-link>
        <router-link :to="{ name: SUBSCRIPTION_ROUTE }" v-on:click="closeMobile">
          <li :class="[route == SUBSCRIPTION_ROUTE ? 'selected' : null, 'nav-items']">
            <span class="router-link">
              <font-awesome-icon icon="fa-solid fa-credit-card" class="fa" />
              <span class="d-none d-lg-block nav-label">Subscriptions</span>
            </span>
          </li>
        </router-link>
        <router-link :to="{ name: PAYMENTS_ROUTE }" v-on:click="closeMobile">
          <li :class="[route == PAYMENTS_ROUTE ? 'selected' : null, 'nav-items']">
            <span class="router-link">
              <font-awesome-icon icon="fa-solid fa-receipt" class="fa" />
              <span class="d-none d-lg-block nav-label">Payments</span>
            </span>
          </li>
        </router-link>
      </ul>
    </div>
    <div v-if="account" class="card profile-card">
      <div class="card-body">
        <div class="content">
          <h5 class="name text-center">{{ $filters.fullName(account.fname, account.lname) }}</h5>
          <h6 class="email text-center">{{ account.email }}</h6>
          <button v-on:click="logout()" class="btn btn-custom-primary col-12">
            <span>Logout</span>
          </button>
          <small class="text-center">ABOL.1.0.0</small>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  ACCOUNTS_ROUTE,
  ACCOUNT_DETAIL_ROUTE,
  DASHBOARD_ROUTE,
  PAYMENTS_ROUTE,
  SUBSCRIPTION_ROUTE,
  SUBSCRIPTION_PLANS_ROUTE,
  VERIFICATIONS_ROUTE,
} from "@/router/routes";
import { CLEAR_ERRORMSG, LOGOUT } from "@/store/action_types";
import { DEFAULT_ERROR_MSG, TOAST_GLOBAL_CONFIG } from "@/utils/const";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faGrip,
  faUserGroup,
  faCircleCheck,
  faCreditCard,
  faLayerGroup,
  faReceipt,
  faXmark,
  faBars,
} from "@fortawesome/free-solid-svg-icons";

library.add(faGrip, faUserGroup, faCircleCheck, faCreditCard, faLayerGroup, faReceipt, faXmark, faBars);

export default {
  data() {
    return {
      DASHBOARD_ROUTE,
      ACCOUNTS_ROUTE,
      VERIFICATIONS_ROUTE,
      SUBSCRIPTION_ROUTE,
      SUBSCRIPTION_PLANS_ROUTE,
      PAYMENTS_ROUTE,
      mobileOpen: false,
    };
  },
  computed: {
    route() {
      return this.$route.name;
    },
    // Keep "Accounts" highlighted on both the list and the detail page.
    isAccountsRoute() {
      return this.route === ACCOUNTS_ROUTE || this.route === ACCOUNT_DETAIL_ROUTE;
    },
    errorMessage() {
      return this.$store.getters.errorMsg;
    },
    account() {
      return this.$store.getters.account.data;
    },
  },
  watch: {
    errorMessage: {
      handler(val) {
        if (val != null) {
          this.$toast.error(val ?? DEFAULT_ERROR_MSG, TOAST_GLOBAL_CONFIG);
          this.$store.dispatch(CLEAR_ERRORMSG);
        }
      },
    },
  },
  methods: {
    logout() {
      this.$store.dispatch(LOGOUT).then(() => {
        this.$router.go();
      });
    },
    openMobile() {
      this.mobileOpen = true;
      document.body.classList.add("ehs-mobile-nav-open");
    },
    closeMobile() {
      this.mobileOpen = false;
      document.body.classList.remove("ehs-mobile-nav-open");
    },
    onToggleMobileNav(event) {
      const next = event?.detail;
      if (typeof next === "boolean") {
        next ? this.openMobile() : this.closeMobile();
      } else {
        this.mobileOpen ? this.closeMobile() : this.openMobile();
      }
    },
  },
  mounted() {
    window.addEventListener("ehs:toggle-mobile-nav", this.onToggleMobileNav);
  },
  beforeUnmount() {
    window.removeEventListener("ehs:toggle-mobile-nav", this.onToggleMobileNav);
    document.body.classList.remove("ehs-mobile-nav-open");
  },
};
</script>
<style scoped>
.sidenav {
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding-right: 0px;
  padding-bottom: 3px;
  background-color: var(--ehs-color-sidebar) !important;
  border-right: 1px solid var(--ehs-color-sidebar-border);
}

.sidenav hr {
  margin-left: 18px;
  margin-right: 18px;
  margin-bottom: 18px;
  margin-top: 4px;
  border-color: var(--ehs-color-sidebar-border);
  opacity: 1;
}

.brand-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 22px 20px 6px;
}

.brand-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  width: 28px;
  height: 28px;
  border-radius: var(--ehs-radius-sm);
  background: linear-gradient(135deg, var(--ehs-color-primary) 0%, #bcdc44 100%);
  color: #ffffff;
  font-weight: 700;
  font-size: 0.7rem;
  line-height: 1;
  letter-spacing: -0.05em;
  position: relative;
  box-shadow: 0 4px 12px rgba(115, 196, 29, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.brand-bracket {
  font-family: var(--ehs-font-mono);
  font-size: 0.95rem;
  font-weight: 600;
  opacity: 0.9;
  line-height: 1;
}

.brand-glyph {
  display: inline-block;
  width: 5px;
  height: 5px;
  background-color: #ffffff;
  border-radius: 1px;
  margin: 0 1px;
}

.brand-name {
  color: var(--ehs-color-sidebar-text-strong);
  font-family: var(--ehs-font-display);
  font-size: 1.05rem;
  font-weight: 700;
  letter-spacing: -0.035em;
}

.sidenav ul {
  list-style: none;
  width: 100%;
  margin-block-start: 0px;
  padding-inline-start: 0px;
}

.sidenav ul a:hover {
  text-decoration: unset;
}

.sidenav ul .nav-items {
  width: 90%;
  margin-left: 5%;
  font-weight: 500;
  font-size: 0.875rem;
  line-height: 1.4rem;
  padding-top: 0.55rem;
  padding-bottom: 0.55rem;
  margin-top: 3px;
  color: var(--ehs-color-sidebar-text) !important;
  border-radius: var(--ehs-radius-md) !important;
  letter-spacing: -0.005em;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.sidenav ul .selected {
  width: 90%;
  margin-left: 5%;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.4rem;
  padding-top: 0.55rem;
  padding-bottom: 0.55rem;
  margin-top: 3px;
  color: var(--ehs-color-sidebar-text-strong) !important;
  background-color: var(--ehs-color-sidebar-active);
  border-radius: var(--ehs-radius-md) !important;
  letter-spacing: -0.005em;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.04);
}

.sidenav ul .nav-items:hover {
  background-color: var(--ehs-color-sidebar-hover);
  color: var(--ehs-color-sidebar-text-strong) !important;
}

.sidenav ul .selected:hover {
  background-color: var(--ehs-color-sidebar-active);
  color: var(--ehs-color-sidebar-text-strong) !important;
}

.sidenav ul .router-link {
  display: flex;
  align-items: center;
}

.sidenav .profile-card {
  border: 1px solid var(--ehs-color-sidebar-border);
  padding: 0px;
  border-radius: var(--ehs-radius-md);
  width: 90%;
  margin-left: 5%;
  box-shadow: none;
  background-color: var(--ehs-color-sidebar-elevated);
  margin-top: auto;
}

.sidenav .profile-card .card-body {
  padding: 0px;
}

.sidenav .profile-card .card-body .content {
  padding: 14px;
}

.sidenav .profile-card .name {
  color: var(--ehs-color-sidebar-text-strong);
  font-size: 0.875rem;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 2px;
  letter-spacing: -0.01em;
}

.sidenav .profile-card .email {
  color: var(--ehs-color-sidebar-muted);
  font-size: 0.7rem;
  font-weight: 400;
  margin-bottom: 12px;
  word-break: break-all;
}

.sidenav .profile-card .btn-custom-primary {
  background-color: var(--ehs-color-primary);
  border-color: var(--ehs-color-primary);
  color: #ffffff;
  font-size: 0.8rem;
  font-weight: 600;
  border-radius: var(--ehs-radius-sm);
  padding: 0.45rem 0.9rem;
}

.sidenav .profile-card .btn-custom-primary:hover {
  background-color: var(--ehs-color-primary-hover);
  border-color: var(--ehs-color-primary-hover);
  color: #ffffff;
}

.sidenav .profile-card .content small.text-center {
  display: block;
  text-align: center;
  margin-top: 5px;
  font-size: 0.7rem;
  color: var(--ehs-color-sidebar-muted);
}

.sidenav-backdrop,
.sidenav-close {
  display: none;
}

@media (max-width: 1000px) {
  .sidenav {
    padding-left: 15px;
  }

  .sidenav .links .fa {
    font-size: 20px;
    padding-top: 5px;
    padding-bottom: 5px;
    width: 50%;
    margin: 0 auto;
  }
}

@media (min-width: 1000px) {
  .sidenav ul .nav-items {
    padding-left: 15px;
  }
}

@media (min-width: 1500px) {
  .sidenav {
    padding-left: 15px;
  }
}

@media (min-width: 1000px) and (max-width: 1500px) {
  .sidenav {
    padding-left: 18px;
  }
}

@media (max-width: 991.98px) {
  .sidenav {
    position: fixed !important;
    top: 0;
    left: 0;
    z-index: 1200;
    width: 78vw !important;
    max-width: 300px;
    height: 100vh;
    padding: 0 0 16px;
    background-color: var(--ehs-color-sidebar) !important;
    border-right: 1px solid var(--ehs-color-sidebar-border);
    box-shadow: 8px 0 32px rgba(0, 0, 0, 0.35);
    transform: translateX(-105%);
    transition: transform 0.28s cubic-bezier(0.22, 1, 0.36, 1);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }

  .sidenav .links {
    flex: 1 1 auto;
    overflow-y: auto;
    min-height: 0;
  }

  .sidenav.mobile-open {
    transform: translateX(0);
  }

  .sidenav-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    z-index: 1100;
    background: rgba(15, 23, 42, 0);
    pointer-events: none;
    transition: background 0.28s ease;
  }

  .sidenav-backdrop.is-open {
    background: rgba(15, 23, 42, 0.42);
    pointer-events: auto;
  }

  .sidenav-close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 12px;
    right: 12px;
    width: 36px;
    height: 36px;
    border: 1px solid var(--ehs-color-sidebar-border);
    border-radius: 50%;
    background: var(--ehs-color-sidebar-elevated);
    color: var(--ehs-color-sidebar-text-strong);
    cursor: pointer;
    box-shadow: none !important;
    z-index: 1;
  }

  .sidenav hr {
    margin-top: 12px;
    margin-bottom: 18px;
  }

  .sidenav ul .nav-items,
  .sidenav ul .selected {
    width: 92%;
    margin-left: 4%;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 16px;
    font-size: 0.8rem;
  }

  .sidenav .links .fa {
    font-size: 0.85rem;
    width: auto;
    margin: 0 12px 0 0;
  }

  .sidenav ul .nav-label {
    display: inline-block !important;
    font-size: 0.8rem;
  }

  .sidenav .profile-card {
    width: 92%;
    margin-left: 4%;
    margin-right: 4%;
    margin-top: 0;
    margin-bottom: 0;
    flex-shrink: 0;
  }
}
</style>
